import React from 'react';

import { StyledLogo, StyledLogosContainer } from './logos-group.styled';
import { TLogos } from './logos-group.types';

export function LogosGroup({
    logos,
    logoWidth,
    invert,
    smallGap,
}: {
    logos: TLogos;
    logoWidth: string;
    invert?: boolean;
    smallGap?: boolean;
}) {
    return (
        <StyledLogosContainer
            $width={logoWidth}
            style={{ gap: smallGap ? undefined : '40px' }}
        >
            {logos.map((logo, index) => (
                <a
                    key={index}
                    href={logo.link}
                    target="_blank"
                    rel="noreferrer"
                >
                    <StyledLogo
                        $width={logoWidth}
                        $invert={invert}
                        src={logo.logo}
                        alt={logo.alt}
                    />
                </a>
            ))}
        </StyledLogosContainer>
    );
}
